module.exports = {
  1: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  56: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  97: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  137: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  8453: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  17000: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  42161: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  43113: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  43114: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  59140: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  59144: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  80001: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  84532: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  421614: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  11155111: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  245022926: '0xD82E10B9A4107939e55fCCa9B53A9ede6CF2fC46',
  245022934: '0x076065A05f07EB65EefEfF803EcFb192B8c015e1',
}
